import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { environment } from '@resume-portal/environment'
import { axios } from '@resume-portal/lib'
import { IReportProblemRequestDto } from '@resume-portal/models'

class ReportProblemService {
  private readonly baseUrl = `${environment.GORILLA_RESUME_API_URL}/ReportProblem`

  reportProblem(payload: IReportProblemRequestDto): Observable<void> {
    const formData = new FormData()
    formData.append('organizationId', payload.organizationId)
    formData.append('description', payload.description)

    if (payload.resume) {
      formData.append('resume', payload.resume)
    }

    if (payload.files && payload.files.length > 0) {
      payload.files.forEach((additionalFile) => {
        formData.append(`files`, additionalFile)
      })
    }

    return axios
      .post(this.baseUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .pipe(map(() => {}))
  }
}

export const reportProblemService = new ReportProblemService()
